import { styled } from 'styled-components';

export const AppStyles = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  .app__container {
    padding-top: 1em;
    height: 100%;
    display: flex;
    width: 1200px;
    column-gap: 30px;
    position: relative;
    .model__container {
      height: 100%;
      width: 70%;
      .main__frame {
        width: 100%;
        height: 75%;
        border: none;
      }
      &.position__sticky {
        /* > iframe {
          position: sticky;
          top: 0px;
        } */
      }
        
    }
      
      .ar-btn {
          position: absolute;
            top: 10px;
            left: 10px;
          height: 40px;
          width: 40px;
          > img {
              height: 100%;
              width: 100%;
              object-fit: contain;
          }
          
          @media screen and (min-width: 768px) {
              display: none;
          }
      }
      
    .configurator__container {
      height: 100%;
      width: 30%;
      .configurator__main {
        height: 100%;
        max-width: 310px;
        display: flex;
        flex-direction: column;
        > .languages__container {
          display: flex;
          column-gap: 10px;
          padding-bottom: 10px;
          > .language__item {
            > img {
              width: 30px;
              cursor: pointer;
            }
            &.active {
              /* border: 1px solid var(--primary-blue); */
              transform: scale(1.1) translateY(-5px);
              transition: all ease 250ms;
            }
          }
        }
        ::-webkit-scrollbar {
          width: 10px;
        }
        ::-webkit-scrollbar-track {
          background: #f1f1f1;
        }
        ::-webkit-scrollbar-thumb {
          background: #c6bfbf;
          border-radius: 5px;
        }
        ::-webkit-scrollbar-thumb:hover {
          background: #ababab;
        }
        .confiurator__values__container {
          width: 100%;
          flex: 1;
          overflow-y: auto;
          .option__container {
            .option__main__container {
              ::-webkit-scrollbar {
                width: 10px;
              }
              ::-webkit-scrollbar-track {
                background: #f1f1f1;
              }
              ::-webkit-scrollbar-thumb {
                background: #c6bfbf;
              }
              ::-webkit-scrollbar-thumb:hover {
                background: #ababab;
              }
              font-size: 15px;
              padding-bottom: 28px;
              display: flex;
              flex-direction: column;
              overflow: hidden;
              position: relative;
              .toggle__tag {
                user-select: none;
                cursor: pointer;
                padding-left: 12px;
                height: 30px;
                .option__number {
                  display: inline-block;
                  width: 22px;
                  height: 22px;
                  text-align: center;
                  color: white;
                  border-radius: 50%;
                  background-color: var(--primary-blue);
                }
                .tag__text {
                  font-weight: 600;
                  margin-left: 20px;
                }
              }
              .toggle__container {
                position: relative;
                .react-tooltip {
                  z-index: 10;
                }
                height: 0px;
                overflow: hidden;
                transition: all ease 350ms;
                width: 100%;
                flex-direction: column;
                &.display {
                  height: 250px;
                }
                .buttons__container {
                  padding: 0px 12px 12px;
                  width: 100%;
                  background-color: white;
                  bottom: 0px;
                  left: 0px;
                  border-left: 1px solid lightGray;
                  height: 35px;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  .button__prev,
                  .button__next {
                    border-radius: 4px;
                    cursor: pointer;
                    padding: 6px;
                    transition: all ease 250ms;
                    user-select: none;
                    display: flex;
                    column-gap: 6px;
                    align-items: center;
                  }
                  .button__prev {
                    &:hover {
                      background-color: var(--primary-lightGray);
                    }
                  }
                  .button__next {
                    color: var(--primary-blue);
                    &:hover {
                      background-color: var(--primary-bg-blue);
                    }
                  }
                }
              }
              .selecting__value {
                color: var(--primary-darkerGray);
                display: none;
                position: absolute;
                bottom: 12px;
                left: 60px;
                &.show {
                  display: inline-block;
                }
              }
            }
          }
        }

        .submit__button__container {
          width: 100%;
          padding-bottom: 20px;
          .submit__button {
            width: 100%;
            border: none;
            background-color: #006b67;
            color: white;
            padding: 8px 0;
            font-weight: 500;
            cursor: pointer;
            transition: all ease 250ms;
            &:hover {
              background-color: rgba(0, 107, 103, 0.8);
            }
            &.loading {
              background-color: var(--primary-darkGray);
              cursor: not-allowed;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .app__container {
      padding-top: 0px;
      flex-direction: column;
      .model__container {
        height: 40%;
        width: 100%;
        .main__frame {
          height: 100%;
        }
      }
      .configurator__container {
        height: 60%;
        width: 100%;
        .configurator__main {
          padding-top: 30px;
          margin-left: auto;
          margin-right: auto;
        }
      }
    }
  }

  @media screen and (min-width: 768.001px) and (max-width: 1199.999px) {
    .app__container {
      width: 100%;
      .model__container {
        width: 65%;
        .main__frame {
        }
      }
      .configurator__container {
        width: 35%;
        .configurator__main {
          .option__container {
            .option__main__container {
              ::-webkit-scrollbar {
              }
              ::-webkit-scrollbar-track {
              }
              ::-webkit-scrollbar-thumb {
              }
              ::-webkit-scrollbar-thumb:hover {
              }
              .toggle__tag {
                .option__number {
                }
                .tag__text {
                }
              }
              .toggle__container {
                .react-tooltip {
                }
                &.display {
                }
                .buttons__container {
                  .button__prev,
                  .button__next {
                  }
                  .button__prev {
                    &:hover {
                    }
                  }
                  .button__next {
                    &:hover {
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  @media screen and (min-width: 1550px) {
    .app__container {
      width: 80%;
      .model__container {
        width: 75%;
        .main__frame {
          height: 80%;
        }
      }
      .configurator__container {
        width: 25%;
        .configurator__main {
          .option__container {
            .option__main__container {
              ::-webkit-scrollbar {
              }
              ::-webkit-scrollbar-track {
              }
              ::-webkit-scrollbar-thumb {
              }
              ::-webkit-scrollbar-thumb:hover {
              }
              .toggle__tag {
                .option__number {
                }
                .tag__text {
                }
              }
              .toggle__container {
                .react-tooltip {
                }
                &.display {
                }
                .buttons__container {
                  .button__prev,
                  .button__next {
                  }
                  .button__prev {
                    &:hover {
                    }
                  }
                  .button__next {
                    &:hover {
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
